if(!customElements.get('product-main')) {
  class ProductMain extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.section;
      this.productData = JSON.parse(this.querySelector('[type="application/json"][data-product-json]').textContent);
      let inventoryScript = this.querySelector('[type="application/json"][data-inventory-json]');
      if (inventoryScript) {
        let inventoryData = JSON.parse(inventoryScript.textContent);
        this.productData.variants.forEach(v => { v.inventory_quantity = inventoryData[v.id] ?? null; });
      }
      this.variantsElement = this.querySelector('product-variants');
      this.sellingPlanElement = this.querySelector('product-selling-plan');
      this.quantityElement = this.querySelector('.quantity-input');
      this.badgesSale = this.querySelectorAll('.badge.sale');
      this.badgesSoldOut = this.querySelectorAll('.badge.sold-out');
      this.variantTitleElements = this.querySelectorAll('[data-variant-title]');
      this.optionValues = {}
      const requiredOptionsSetting = ([] || []).concat(this.dataset.manualSelect ? this.dataset.manualSelect.split(',') : []).map(x=>x.trim());
      const requiredOptionsSettingUnique = [...new Set(requiredOptionsSetting)];
      this.requiredOptions = this.productData.options.filter(x=>(requiredOptionsSettingUnique.indexOf(x)>-1 || requiredOptionsSettingUnique.indexOf('*')>-1) && this.getOptionValues(x).length>1);
      this.originalRequiredOptions = [...this.requiredOptions];
      if (this.requiredOptions.length > 0) {
        this.setAttribute('data-required', 'true');
      }
      if (this.quantityElement) {
        this.quantityElement.addEventListener('change', this.onQuantityElementChange.bind(this));
      }
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
    }

    getOptionValues(optionName) {
      if (!this.optionValues[optionName]) {
        function filterUnique(value, index, array) {
          return array.indexOf(value) === index;
        }
        var ix = this.productData.options.indexOf(optionName);
        this.optionValues[optionName] = this.productData.variants.map(v=>v['option'+(1+ix)]).filter(filterUnique);
      }
      return this.optionValues[optionName];
    }

    isSwatchSelected() {
      return this.requiredOptions.length == 0 || this.requiredOptions.length < this.originalRequiredOptions.length;
    }

    required(option, newValue) {
      var ix = this.requiredOptions.indexOf(option);
      if (typeof(newValue)!='undefined') {
        if (ix > -1) {
          this.requiredOptions.splice(ix, 1);
          if (this.requiredOptions.length == 0) {
            this.setAttribute('data-required', 'false');
          }
          return false;
        }
      }
      return ix > -1;
    }

    getCurrentVariant() {
      return this.variantsElement.getCurrentVariant();
    }
    getCurrentPlan() {
      return this.sellingPlanElement?.getCurrentPlan();
    }
    getQuantity() {
      return this.quantityElement ? this.quantityElement.value : 1;
    }
    onQuantityElementChange() {
      this.dispatchEvent(new CustomEvent('quantityChange', {detail: {"quantity":this.getQuantity()}}));
    }
    onVariantChange() {
      //lightweight update of elements that not worth creating their own components
      var variant = event.detail.variant;
      this.variantTitleElements.forEach(element=>{
        element.innerHTML = variant.title;
      });
      this.badgesSale.forEach(element=>{
        var sale = '';
        var percent = Math.floor((1 - variant.price / variant.compare_at_price) * 100);
        if (percent > 0) {
          sale = element.dataset.msgtpl.replace('[percent]', percent);
        }
        element.style.display = variant.available && sale ? '' : 'none';
        element.innerHTML = sale;
      });
      /*
      this.badgesSoldOut.forEach(element=>{
        element.style.display = variant.available ? 'none' : '';
      });
      */// We need to hide the variant that has true on Metafield "Hide Variant" - COM-49
      this.querySelectorAll('product-swatch [data-variant-price-option]').forEach(x=>{
        var currentSwatch = x.closest('product-swatch');
        var optionNumber = currentSwatch.dataset.option;
        var value = x.dataset.variantPriceOption;
        var variantOptions = [...variant.options]; //get array copy
        variantOptions[optionNumber - 1] = value;
        var targetVariant = this.productData.variants.find((x)=>{
          return x.options.length==variantOptions.length
            && x.options.every((val, index) => val === variantOptions[index]);
        });
        
        var singleSwatch = x.closest('.swatch');
        if (targetVariant && targetVariant.custom?.hide_variant) {
          singleSwatch.style.display = 'none'
        } else {
          singleSwatch.style.display = 'block'
        }

        if (targetVariant && targetVariant.available) {
          singleSwatch.setAttribute('data-available', 'true');
        } else if (
          targetVariant && 
          targetVariant.inventory_quantity != null && 
          targetVariant.inventory_quantity <= parseInt(this.dataset.inventoryThreshold)
        ) {
          singleSwatch.setAttribute('data-available', 'false');
        } else {
          singleSwatch.setAttribute('data-available', 'false');
        }
      })
    }
  }
  customElements.define('product-main', ProductMain);

  class ComponentProductCardAtc extends ProductMain {
    constructor() {
      super()
      this.swatches = this.querySelector('.swatch-group')
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
      this.defaultImage = this.querySelector('.img.main').getAttribute('data-srcset');
      this.currentImageUrl = '';
      this.imageObserver = null;
      this.clickOutHandler = null;
      let imageContainer = this.querySelector('.image-container');
      if (imageContainer && imageContainer.querySelector('.hover-img')) {
        let hover = false;
        this.addEventListener('mouseleave', (e)=>{
          hover && (hover=false,imageContainer.classList.remove("hover"));
        });
        this.addEventListener('mousemove', (e)=>{
          let bounds = imageContainer.getBoundingClientRect();
          if (e.y>bounds.top && e.y<bounds.bottom && e.x>bounds.left && e.x<bounds.right) {
            hover || (hover=true,imageContainer.classList.add("hover"))
          } else {
            hover && (hover=false,imageContainer.classList.remove("hover"));
          }
        });
      }
      
      this.optionsButton = this.querySelector('.atc-options');
      if (this.optionsButton) {
        this.optionsButton.addEventListener('click', this.openOptions.bind(this));
      }

      this.quickViewBtn = this.querySelector('.quick-view-trigger')
      if(this.quickViewBtn) {
        this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this));
      }

      var self = this;
      if (self.classList.contains('colors-out')) {
        setTimeout(function() { //workaround on ajax call, the following code mistakenly inits ProductSwatch before ProductVariants
          var origSwatches = self.querySelector('product-swatch.color-swatches');
          if (origSwatches) {
            //need to duplicate the whole product-variants component
            var pv = origSwatches.closest('product-variants');
            var tag = pv.outerHTML.replace('name="id"', '');
            var wrapper = document.createElement('div');
            wrapper.style.display = 'none';
            //must insert as Element, not HTML, otherwise the component would be reconstructed
            self.querySelector('add-to-cart-form').insertAdjacentElement('beforebegin', wrapper);
            wrapper.innerHTML = tag;
            //move the swatches inside the add-to-cart-form component to use existing css.
            self.querySelector('add-to-cart-form').insertAdjacentElement('afterbegin', wrapper.querySelector('product-swatch.color-swatches'));
          }
        }, 10);
      }
      if (window.LinkPrefetch && window.LinkPrefetch.addHoverListener) {
        window.LinkPrefetch.addHoverListener(this);
      }
    }

    openOptions(e) {
      e.preventDefault()
      var container = this.querySelector('.atc-options-wrapper form');
      this.querySelector('.atc-options-wrapper').classList.add('open');
      $s.trapFocus(container);
      var self = this;
      if (!this.clickOutHandler) {
        this.querySelector('.close').addEventListener('click', this.closeOptions.bind(this));
      }
      this.clickOutHandler = function(evt) {
        if(container !== evt.target && !container.contains(evt.target)) {
          self.closeOptions.bind(self)();
        }
      }
      document.addEventListener('mousedown', this.clickOutHandler);
    }
    closeOptions() {
      this.querySelector('.atc-options-wrapper').classList.remove('open');
      document.removeEventListener('mousedown', this.clickOutHandler);
      $s.removeTrapFocus();
    }

    openQuickView(e) {
      e.preventDefault()
      $s.showLoadingOverlay();
      var qvUrl = this.quickViewBtn.dataset.url;
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          var enhancedDescription = section.querySelector('.enhanced-description');
          if (enhancedDescription && enhancedDescription.querySelector('.expandable-default-open')) {
            enhancedDescription.querySelector('.accordion.open').classList.remove('open');
            enhancedDescription.querySelector('[aria-expanded=true]').ariaExpanded = false;
            enhancedDescription.querySelector('.expandable-default-open').classList.remove('expandable-default-open');
          }
          $s.openModal(section, 'product-quick-view');
          $s.globalEval(section);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    onVariantChange(event) {
      super.onVariantChange(event);
      var variant = event.detail.variant;
      var image = variant.featured_media && super.isSwatchSelected() ? variant.featured_image : null;
      var img = this.querySelector('.img.main');
      var width = Math.ceil(img.width / 100) * 100;
      if (image && img.classList.contains('under-video')) {
        this.querySelector('.video-wrap').remove();
        img.classList.remove('under-video');
      }

      if (img.classList.contains('lazyload')) {
        img.setAttribute('data-srcset', image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage);
      } else {
        this.currentImageUrl = image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage;
        if (!this.imageObserver) {
          if (!img.classList.contains('lazyloaded')) {
            this.imageObserver = new MutationObserver(mutations => {
              if (img.classList.contains('lazyloaded')) {
                this.imageObserver.disconnect();
                this.imageObserver = null;
                img.setAttribute('srcset', this.currentImageUrl);
              }
            });
            var config = { attributes: true, attributeFilter: ['class']};
            this.imageObserver.observe(img, config);
          } else {
            img.setAttribute('srcset', this.currentImageUrl);
          }
        }
      }

      //update urls to variant
      var links = this.querySelectorAll('.product-card-url[href]');
      if (links.length > 0 && this.requiredOptions.length < this.originalRequiredOptions.length) {
        var productUrl = new URL(links[0].getAttribute('href'), location.origin);
        productUrl.searchParams.set('variant', variant.id);

        if (variant.product_id) {
          productUrl.searchParams.set('product', variant.product_id);
        }
        
        links.forEach(link=>{
          link.setAttribute('href', productUrl.toString());
        });
        if (this.quickViewBtn) {
          this.quickViewBtn.dataset.url = productUrl.toString();
        }
      }

      // Update badges
      var badgesChild = this.querySelectorAll('.product-badges .badges-child');
      if (badgesChild.length > 0) {
        badgesChild.forEach(badge=>{
          if(badge.classList.contains('badges-product-' + variant.product_id)) {
            badge.classList.remove('hide');
          }else{
            badge.classList.add('hide');
          }
        });
      }

    }
  }
  customElements.define('product-card-atc', ComponentProductCardAtc);
}

if(!customElements.get('product-buttons')) {
  class ProductButtons extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.dynamicButtons = this.querySelector('.shopify-payment-button');
      //this.notifyButton = this.mainElement.querySelector('.klaviyo-bis-trigger');
      this.simplisticBisTrigger = this.querySelector('.simplistic-bis-trigger');
      this.mainAddButton = this.mainElement.querySelector('.btn.add');
      this.button = this.querySelector('.btn.add');
      this.hasBisHiddenTag = this.mainElement.classList.contains('has-bis-hidden-tag');
      this.ampBisBlock = this.mainElement.querySelector('.amp-bis-block');

      if (this.button != this.mainAddButton) {
        this.button.addEventListener('click', (event)=>{
          event.preventDefault();
          event.stopImmediatePropagation();
          this.mainAddButton.click();
        });
      }

      // Start - Observe Rise.Ai Gift Card Button (for Gift Card product) -> to remove add class
      const config = { attributes: false, childList: true, subtree: false };
      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.type === "childList") {
            mutation.addedNodes.forEach(node => {
              if (node.classList.contains('GiftWizard-gift-button')) {
                node.classList.remove('add');
              }
            });
          }
        }
      };

      const observer = new MutationObserver(callback);

      observer.observe(this, config);
      // End - Observe Rise.Ai Gift Card Button (for Gift Card product) -> to remove add class

      this.mainElement.addEventListener('variantChange', (e)=>{
        var requiredBtn = this.querySelector('.btn.selection-required');
        // The inventory threshold only governs swatch availability (see the "Inventory Threshold"
        // setting), never the purchase CTA: gate the CTA on variant.available alone.
        const variant = e.detail.variant;
        const addBtn = this.querySelector('.btn.add');
        const soldOutMessage = this.querySelector('.custom-sold-out-message');
        const isGiftCard = this.mainElement.classList.contains('gift-cards');

        if (this.required() && requiredBtn) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          requiredBtn.style.display = '';
          requiredBtn.innerHTML = this.requiredMessage;
        } else if(variant && variant.available) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.remove('hide');
          }

          if (addBtn) addBtn.style.display = '';
          //this.notifyButton.style.display = 'none';
          if(this.simplisticBisTrigger != null){
            this.simplisticBisTrigger.classList.add('hide');
          }
          if (soldOutMessage) soldOutMessage.style.display = 'none';

          if (requiredBtn) requiredBtn.style.display = 'none';
      	} else {
          // Either there is no variant for the selected combination, or it is sold out. Every CTA
          // gets an explicit state here so nothing carries over from the previous variant.
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }

          if (isGiftCard) {
            setTimeout(()=>{
              const activeImage = document.querySelector('product-gallery .active img');
              const recipientImage = document.querySelector('recipient-form [name="properties[__image]"]');
              if (activeImage && recipientImage) {
                recipientImage.value = activeImage.dataset.srcset.split('?v=')[0];
              }
            }, 250);
          } else if (addBtn) {
            addBtn.style.display = 'none';
          }

          // With no valid variant the BIS flow has no variant id to submit, so fall back to the
          // sold-out message.
          const useSoldOutMessage = this.hasBisHiddenTag || !variant;
          if (soldOutMessage) soldOutMessage.style.display = useSoldOutMessage ? '' : 'none';
          //this.notifyButton.style.display = useSoldOutMessage ? 'none' : '';
          if(this.simplisticBisTrigger != null){
            this.simplisticBisTrigger.classList.toggle('hide', useSoldOutMessage);
          }

          if (requiredBtn) requiredBtn.style.display = 'none';
      	}
      });
      if(this.simplisticBisTrigger != null){
        this.simplisticBisTrigger.addEventListener('click', (e)=>{
          console.log('BIS v2');
          const ampButton = document.getElementById('BIS_trigger');
          if (ampButton) {
            ampButton.click();
            return;
          }
          var customerEmail = this.simplisticBisTrigger.dataset.email;
          var customModalText = this.simplisticBisTrigger.dataset.modalText;
          var variantId = this.simplisticBisTrigger.closest('form').querySelector('[name="id"]').value;
          var productId = this.simplisticBisTrigger.closest('form').querySelector('[name="product_id"]').value;
          $s.bisModal({text: window.klaviyo_body_content, variant_id: variantId, product_id: productId, email: customerEmail, customModalText: customModalText});
        });
      }
    }

    required() {
      if (this.mainElement.requiredOptions.length > 0) {
        this.requiredMessage = '';
        var label = this.mainElement.requiredOptions[0];
        var firstLetter = label[0].toLowerCase();
        var prep = 'aeiou'.indexOf(firstLetter)>-1 ? 'an' : 'a'; //english support only
        this.requiredMessage = lngg.product_main__select_option_label.replace('Select a ', 'Select ' + prep + ' ').replace(new RegExp(/{{ *option_name *}}/), label);
        return true;
      }
      return false;
    }
  }
  customElements.define('product-buttons', ProductButtons);
}

if(!customElements.get('product-sku')) {
  class ProductSKU extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
      	if(e.detail.variant) {
          if(e.detail.variant.sku) {
            this.closest('.module').style.display = 'block';
            this.innerHTML = e.detail.variant.sku;
          }else{
            this.closest('.module').style.display = 'none';
          }
      	}
      });
    }
  }
  customElements.define('product-sku', ProductSKU);
}

if(!customElements.get('product-gallery') && !customElements.get('product-thumbs')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.itemsWrapper = this.querySelector('.items-wrapper');
      this.desktopStyle = this.dataset.desktop;
      this.desktopOrientation = this.dataset.desktopOrientation;
      this.mobileStyle = this.dataset.mobile;
      this.slider = false;

      this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this))
      window.addEventListener('mediaChange', this.onMediaChange.bind(this))
      setTimeout(()=>{
        this.onMediaChange();
      }, 10);
    }

    filterMedia(variant) {
      this.mainElement.productData.media.forEach((media)=>{
        var show = true;
        if(media.alt && media.alt!="") {
          var filter = media.alt.split(';');
          filter.forEach((f)=>{
            if(show) {
              var key = f.split(':')[0];
              var values = f.split(':')[1];
              var optionIndex = this.mainElement.productData.options.findIndex(x=>x==key.trim());
              if(optionIndex>=0 && values) {
                var found = false;
                values.split(',').forEach((value)=>{
                  if(variant.options[optionIndex]==value.trim()) {
                    found = true;
                  }
                });
                show = found;
              }
            }
          });
        }
        if(show) {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'block';
        } else {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'none';
        }
      });
      if(this.slider) {
        this.slider.refresh();
      }
    }

    onVariantChange() {
    }

    onMediaChange() {
    }

    initSlider() {
    }

    removeSlider() {
      if(this.slider) {
        this.slider.destroy();
        this.slider = false;
        this.classList.remove('keen');
        this.itemsWrapper.classList.remove('keen-slider');
        this.querySelectorAll('.media-wrap, .thumb-wrap').forEach((slide)=>{
          slide.classList.remove('keen-slider-slide')
        });
      }
    }

    showItem(mediaId, animate=true) {
      if(this.slider) {
        var index = Array.from(this.itemsWrapper.querySelectorAll('.media-wrap, .thumb-wrap'))
          .filter(x=>$s.isVisible(x)).findIndex(x=>x.dataset.mediaId==mediaId);
        if(animate) {
          this.slider.moveToSlideRelative(index, true);
        } else {
          this.slider.moveToSlideRelative(index, true, 0);
        }
      }
    }
  }
  
  class ProductGallery extends ProductMedia {
    constructor() {
      super();

      if(!this.closest('.tingle-modal')) {
        this.querySelectorAll('[data-file]').forEach((media)=>{
          media.addEventListener('click', (e)=>{
            var visibleItems = [];
            this.querySelectorAll('[data-media-id]').forEach((obj)=>{
              if($s.isVisible(obj)) {
                let element  = obj.querySelector('[data-file], video, iframe');
                if(element) {
                  visibleItems.push(element);
                }
              }
            });
            $s.photoSwipe(visibleItems, media);
          });
        });
        //3D Models
        this.querySelectorAll('[data-media-id].model-wrap').forEach((model)=>{
          model.addEventListener('click', (e)=>{
            $s.photoSwipe([model.querySelector('template').content.firstElementChild]);         
          });
        });
      }
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      var animate = e.detail.animate;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant);
        if(variant.featured_media && this.mainElement.isSwatchSelected()) {
          this.showItem(variant.featured_media.id, animate)
        }
      }else if(e.detail.variant.featured_media.id && e.detail.variant.bundle){
        this.showItem(e.detail.variant.featured_media.id, animate);
      }
    }

    onMediaChange() {
      if($s.media.isSmall || this.desktopStyle=='carousel') {
        this.initSlider();
      } else {
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.media-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });

        var breakpoints = {};
        var drag = true;

        if(this.mobileStyle=='dots') {
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            dots: this.querySelector('.keen-dots')
          }
        }
        if(this.querySelector('.keen-arrow')) {
          breakpoints['(min-width: '+(parseInt(window.breakpoints.small) + 0.001) +'rem)'] = {
            prevButton: this.querySelector('.keen-arrow.prev'),
            nextButton: this.querySelector('.keen-arrow.next')
          }
        }

        if(this.mainElement.classList.contains('gift-cards')){
          breakpoints = false;
          drag = false;
        }

        const slides = Array.from(this.itemsWrapper.querySelectorAll(".media-wrap"));
        const activeIndex = slides.findIndex(slide => slide.classList.contains("first"));

        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          wheel: false,
          drag: drag,
          initial: activeIndex >= 0 ? activeIndex : 0,
          slideChanged: (keen)=>{
            $s.pauseAllMedia(this);
            this.dispatchEvent(new CustomEvent('slideChanged', {detail: keen}));
          },
          breakpoints
        });
        
      }

      if(this.parentNode) {
        this.parentNode.style.opacity = 1;
      }
    }
  }
  customElements.define('product-gallery', ProductGallery);

  class ProductThumbs extends ProductMedia {
    constructor() {
      super();
      this.mainGallery = this.mainElement.querySelector('product-gallery');

      this.querySelectorAll('[data-media-id]').forEach((media)=>{
        media.addEventListener('click', (e)=>{
          this.mainGallery.showItem(media.dataset.mediaId);
        });
        media.addEventListener('keydown', (e)=>{
          if(e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.mainGallery.showItem(media.dataset.mediaId);
          }
        });
      });

      this.mainGallery.addEventListener('slideChanged', (e)=>{
        var currentSlide = e.detail.currentSlide();
        if(currentSlide) {
          var currentMediaId = currentSlide.dataset.mediaId;
          var currentSlideElement = this.querySelector('.current-slide');
          if(currentSlideElement) {
            currentSlideElement.classList.remove('current-slide');
          }
          this.querySelector('[data-media-id="'+currentMediaId+'"]').classList.add('current-slide');
          this.showItem(currentMediaId);
        }
      });
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant)
      }
    }

    onMediaChange() {
      if(($s.media.isSmall && this.mobileStyle=='thumbnails') || ($s.media.isMediumUp && (this.desktopStyle=='carousel') )) {
        this.style.display = 'block';
        this.initSlider();
      } else {
        this.style.display = 'none';
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.thumb-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });
        var breakpoints = {};
        breakpoints['(max-width: '+window.breakpoints.medium+')'] = {
          slidesPerView: 4,
          spacing: 10,
          centered: false,
          vertical: false
        }
        breakpoints['(max-width: '+window.breakpoints.small+')'] = {
          slidesPerView: 5,
          spacing: 10,
          centered: false,
          vertical: false
        }
        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          centered: false,
          slidesPerView: 7,
          spacing: 15,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          breakpoints,
          ...(this.desktopOrientation=='vertical' ? {
            vertical: true,
            slidesPerView: 5
          } : {})
        });
      }
    }
  }
  customElements.define('product-thumbs', ProductThumbs);
}

if(!customElements.get('product-price')) {
  class ProductPrice extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.finalPriceElement = this.querySelector('.final') || this.querySelector('.final-price');
      this.comparePriceElement = this.querySelector('.compare') || this.querySelector('.compare-price');
      this.percentageElement = this.querySelector('.price-percentage');
      this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : false

      // WCAG F96: the add-to-cart button renders its price through this element, so injecting
      // screen-reader-only text here would put "Final price:" inside the button's accessible
      // name and break the "visible label is part of the accessible name" requirement.
      this.insideControl = !!this.closest('button, a, [role="button"], summary');
      var originalPricePrefix = this.insideControl ? '' : '<span class="visually-hidden">Original price: </span>'
      var finalPricePrefix    = this.insideControl ? '' : '<span class="visually-hidden">. Final price: </span>'

      this.listenEvents = ['variantChange','sellingPlanChange'];
      if (this.multiplyQuantity)
        this.listenEvents.splice(1, 0, 'quantityChange');

      this.listenEvents.forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          var data = this.mainElement.getCurrentPlan() || this.mainElement.getCurrentVariant();
        	if(data) {
            var quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;
        		if(this.finalPriceElement) this.finalPriceElement.innerHTML = $s.formatMoneyWithoutTrailingZeros(data.price * quantity);

            if(data.compare_at_price > data.price) {
              if(this.comparePriceElement) {
                this.comparePriceElement.classList.remove('hide');
                this.comparePriceElement.innerHTML = originalPricePrefix + $s.formatMoneyWithoutTrailingZeros(data.compare_at_price * quantity);
              }
              if(this.finalPriceElement) this.finalPriceElement.innerHTML = finalPricePrefix + $s.formatMoneyWithoutTrailingZeros(data.price * quantity);
              
              // Update percentage badge
              if(this.percentageElement) {
                var percent = Math.round((data.compare_at_price - data.price) / data.compare_at_price * 100);
                this.percentageElement.textContent = 'Save ' + percent + '%';
                this.percentageElement.style.display = 'flex';
              }
            } else {
              if(this.comparePriceElement) {
                this.comparePriceElement.classList.add('hide');
                this.comparePriceElement.innerHTML = '';
              }
              
              // Hide percentage badge when no discount
              if(this.percentageElement) {
                this.percentageElement.style.display = 'none';
              }
            }
        	} else {
        		if(this.finalPriceElement) this.finalPriceElement.innerHTML = '';
            if(this.comparePriceElement) this.comparePriceElement.innerHTML = '';
            if(this.percentageElement) {
              this.percentageElement.style.display = 'none';
            }
        	}
          this.mainElement.dispatchEvent(new CustomEvent('priceChange', {detail: {price: data.price * quantity}}));
        });
      });
    }
  }
  customElements.define('product-price', ProductPrice);
}

if(!customElements.get('product-variants')) {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.mainElement.variantsInstances = (this.mainElement.variantsInstances || 0) +1;
      this.instanceIndex = this.mainElement.variantsInstances;
      this.variantInput = this.querySelector('[data-variant-id]');
      this.productInput = this.querySelector('[data-product-id]');
      this.options = this.querySelectorAll('[data-option]');
      this.swatchImg = this.querySelector('product-swatch[data-use-img="true"]');
      this.variantsInfo = this.dataset.info ? JSON.parse(this.dataset.info) : null;
      this.mainElement.addEventListener('variantChange', (event)=> {
        if (this.variantInput.value != event.detail.variant.id) {
          this.setVariant(event.detail.variant);
        }

        this.sizeGuidePopupTrigger = document.querySelector('.size-guide-popup-trigger');

        setTimeout(() => {
          if (this.sizeGuidePopupTrigger) {
            document.querySelector('.product-main-element .product-swatch-size-guide .product-swatch .option-name').appendChild(this.sizeGuidePopupTrigger);
          }

          this.compressionLevelWrapper = document.querySelector('.compression-level-wrapper');
          if (this.compressionLevelWrapper) {
            document.querySelector('.product-main-element .product-swatch-size-guide').appendChild(this.compressionLevelWrapper);
          }
        }, 1000);
      })

      this.bindOptions();
      setTimeout(()=>{
        this.variantChange(this.getCurrentVariant(), false);
        this.bindInfoElements();
      }, 10);

      this.bulkDefaultValue = false;
    }

    getOptionInfo(optionName) {
      return (this.variantsInfo ? this.variantsInfo.find(x=>x.title==optionName) : null) || {};
    }

    getOptionInfoIcon(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.description) {
        html = `
          <div class="option-info-icon">
            <button type="button" class="btn-open">?</button>
            <div class="option-info-content animation">${info.description}</div>
          </div>
        `;
      }

      return html;
    }
    getOptionInfoLink(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.link_text) {
        if (info.link_target_image) {
          html = `
            <button type="button" class="option-info-link link" data-image-width="${info.link_target_image_native_width}" data-image-height="${info.link_target_image_native_height}" data-image="${info.link_target_image}" data-width="${info.link_target_image_width}">${info.link_text}</button>
          `;
        } else {
          html = `
            <a class="option-info-link link" href="${info.link_target_url}" target="_blank">${info.link_text}</a>
          `;
        }

      }

      return html;
    }

    getCurrentVariant() {
      return this.mainElement.productData.variants.find(x=>x.id==this.variantInput.value)
    }

    setVariant(variant) {
      if(typeof variant !== 'object') {
        variant = this.mainElement.productData.variants.find(x=>x.id==variant);
      }
      if(variant) {
        this.refreshOptions(-1, variant);
        this.variantChange(variant);
      }
    }

    updateVariantIdURL(id, paramName='variant') {
      const nextURL = new URL(window.location.href, location.origin);
      nextURL.searchParams.set(paramName, id);
      window.history.replaceState(null, null, nextURL);
    }

    variantChange(variant, animate=true) {
      var productId = this.mainElement.dataset.productId;
      if(variant) {
        this.variantInput.value = variant.id;
        if(this.productInput != null){
          this.productInput.value = productId;
        }
        if(this.closest('.product-card') == null){
          if(this.closest('product-group') == null){
            this.updateVariantIdURL(variant.id);
          }else{
            this.updateVariantIdURL(variant.id, 'variant_id');
          }
        }
      } else {
        this.variantInput.value = '';
        if(this.productInput != null){
          this.productInput.value = '';
        }
      }
      this.previousVariant = variant;
      this.variantInput.dispatchEvent(new Event('change', {bubbles: true}))
      this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant, animate}}));

      if (this.swatchImg) {
        //var variant = this.mainElement.productData.variants.
        var options = ['option1', 'option2', 'option3'];
        var imgOption = options.splice(this.swatchImg.dataset.option/1 -1 ,1);
        this.swatchImg.querySelectorAll('[type="radio"]').forEach(radio=>{
          var label = radio.parentNode.querySelector('.label-inner');
          
          var matchingVariant = this.mainElement.productData.variants.find(v=>v[imgOption]==radio.value && v[options[0]]==variant[options[0]] && v[options[1]]==variant[options[1]]);
          if (!matchingVariant) {
            matchingVariant = this.mainElement.productData.variants.find(v=>v[imgOption]==radio.value);
          }

          if(matchingVariant.bundle_color){
            label.style.backgroundImage = 'url(' +$s.imgUrlFilter(matchingVariant.bundle_color, '80x')+ ')';
          }else if (matchingVariant.featured_image) {
            label.style.backgroundImage = 'url(' +$s.imgUrlFilter(matchingVariant.featured_image.src, '80x')+ ')';
          } else {
            label.style.backgroundImage = '';
          }
        });
      }
    }

    calculateNewVariant(optionChanged, value) {
      var newVariants = this.mainElement.productData.variants;
      this.mainElement.productData.options.forEach((option, index)=>{
        if(optionChanged==index) {
          newVariants = newVariants.filter(x=>x.options[index]==value);
        } else {
          if(index < optionChanged) {
            newVariants = newVariants.filter(x=>x.options[index]==this.previousVariant.options[index]);
          } else {
            // Line commented - was causing a bug.
            //newVariants = newVariants.filter(x=>x.available);
          }
        }
      });
      return newVariants[0];
      
      // COM-75 - Client wants to automatically select the first available Size (option2) after changing Color (option1)
      // var newVariants = this.mainElement.productData.variants;
      // this.mainElement.productData.options.forEach((option, index)=>{
      //   if(optionChanged==index) {
      //     newVariants = newVariants.filter(x=>x.options[index]==value);
      //   } else {
      //     var tmpNewVariants = newVariants.filter(x=>x.options[index]==this.previousVariant.options[index]);
      //     if(tmpNewVariants.length==0) {
      //       tmpNewVariants = newVariants.filter(x=>x.options[index]==newVariants[0].options[index]);
      //     }
      //     newVariants = tmpNewVariants;
      //   }
      // });
      // return newVariants[0];
    }

    bindOptions() {
      this.options.forEach((element)=>{
        element.addEventListener('change', (e)=>{
          let optionIdx = element.dataset.option-1;
          let variant = this.calculateNewVariant(optionIdx, e.target.value);
          this.refreshOptions(element.dataset.option-1, variant);
          this.variantChange(variant);
        });
      });
    }

    bindInfoElements() {
      this.options.forEach((element)=>{
        var infoIcon = element.querySelector('.option-info-icon');
        var infoLink = element.querySelector('button.option-info-link');
        if (infoIcon) {
          $s.initFloatingPanel({container: infoIcon});
        }
        if (infoLink) {
          infoLink.addEventListener('click', (e)=>{
            var imageWidthPX = parseFloat(getComputedStyle(document.documentElement).fontSize) * infoLink.dataset.width;
            var html = `
              <div class="option-info-popup-content" style="width: ${infoLink.dataset.width}rem">
                <img src="${infoLink.dataset.image + (infoLink.dataset.image.indexOf('?')==-1 ? '?' : '&') + 'width='+imageWidthPX}" width="${infoLink.dataset.imageWidth}" height="${infoLink.dataset.imageHeight}" />
              </div>
            `;
            $s.openModal(html, 'option-info-popup');
          });
        }
      });
    }

    getOptionValues(currentVariant) {
      var options = [];
      this.mainElement.productData.options.forEach((option, index)=>{
        if(index==0) {
          var optionValues = this.mainElement.productData.variants.map((variant) => {
            let isAvailable = false;
            const threshold = parseInt(this.mainElement.dataset.inventoryThreshold || 0);

            if (variant && variant.available) {
              isAvailable = true;
            } else if (
              variant &&
              variant.inventory_quantity != null &&
              variant.inventory_quantity <= threshold
            ) {
              isAvailable = false;
            } else {
              isAvailable = false;
            }

            return {
              value: variant.options[index],
              available: isAvailable
            };
          });
        }
        if(index==1) {
          var optionValues = this.mainElement.productData.variants.filter(x=>x.options[0]==currentVariant.option1).map((variant) => {
            let isAvailable = false;
            const threshold = parseInt(this.mainElement.dataset.inventoryThreshold || 0);

            if (variant && variant.available) {
              isAvailable = true;
            } else if (
              variant &&
              variant.inventory_quantity != null &&
              variant.inventory_quantity <= threshold
            ) {
              isAvailable = false;
            } else {
              isAvailable = false;
            }

            return {
              value: variant.options[index],
              available: isAvailable
            };
          });
        }
        if(index==2) {
          var optionValues = this.mainElement.productData.variants.filter(
            x=>x.options[0]==currentVariant.option1 && x.options[1]==currentVariant.option2
          ).map((variant) => {
            let isAvailable = false;
            const threshold = parseInt(this.mainElement.dataset.inventoryThreshold || 0);

            if (variant && variant.available) {
              isAvailable = true;
            } else if (
              variant &&
              variant.inventory_quantity != null &&
              variant.inventory_quantity <= threshold
            ) {
              isAvailable = false;
            } else {
              isAvailable = false;
            }

            return {
              value: variant.options[index],
              available: isAvailable
            };
          });
        }
        var optionValuesUnique = [];
        optionValues.forEach((option, key)=>{
          if(!optionValuesUnique.find(x=>x.value==option.value)) {
            if(option.available) {
              optionValuesUnique.push(option);
            } else {
              if(!optionValues.find((x,y)=>y!=key && x.available && x.value==option.value)) {
                optionValuesUnique.push(option);
              }
            }
          }
        });
        options.push(optionValuesUnique);
      });
      return options;
    }

    refreshOptions(updateOptionIndex=-1, currentVariant) {
      var optionValues = this.getOptionValues(currentVariant);
      this.options.forEach((element)=>{
        let index = element.dataset.option - 1;
        if(index > updateOptionIndex) {
          element.buildOptions(optionValues[index], currentVariant.options[index]);
        }
        var optionValueElement = element.querySelector('.option-value');
        if(optionValueElement) {
          optionValueElement.innerHTML = this.mainElement.classList.contains('template-leggings') ? String(currentVariant.options[index]).replace(/-/g, '–') : currentVariant.options[index];
        }
      });
    }
  }
  customElements.define('product-variants', ProductVariants);
}

if(!customElements.get('product-variant-edit')) {
  class ProductVariantEdit extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.toggles = this.querySelectorAll('.toggle');
      this.toggles.forEach(btn=>{btn.addEventListener('click', this.onToggle.bind(this))});
      this.editing = false;
    }
    onToggle() {
      this.editing = !this.editing;
      var divVariants = this.querySelector('.variants');
      var divInfo = this.querySelector('.info');
      if (this.editing) {
        $s.expand([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.add('open')});
      } else {
        $s.collapse([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.remove('open')});
      }
    }
  }
  customElements.define('product-variant-edit', ProductVariantEdit);
}

if(!customElements.get('product-swatch-bulk')) {
  class ProductSwatchBulk extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      
      this.optionNumber = 0;
      this.label = this.dataset.label;
      this.setAttribute('aria-labelledby', 'swatchgroup-' + this.optionNumber + '-' + this.mainElement.sectionId + '-' + this.variantsElement.instanceIndex);

      this.buildOptionSelector();
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber];
      var defaultValue = currentVariant.options[this.optionNumber];
      var optionElement = document.createElement('div');
      var mainElementId = this.mainElement.dataset.productId;
      var optionNameHandle = $s.handleize(this.label);
      var html = `
          <div class="option-name">
            <span id="${this.getAttribute('aria-labelledby')}">${this.label.replace(' ', '').replace('-', ': ')} </span>
          </div>
          <div class="swatch-group flex"></div>
        `;

      this.innerHTML = html;
      this.buildOptions(optionValues, defaultValue);
    }

    buildOptions(options, defaultValue) {
      var html = '';
      if (options.length > 0) {
        this.setAttribute('role', 'radiogroup');
      }

      var bulkOptions = [];
      var newDefaultValue = false;
      
      var defaultVariantId = parseInt($s.getQueryParam('variant_id'));
      var defaultVariant = this.mainElement.productData.variants.find(({ id }) => id === defaultVariantId);
      if(typeof defaultVariant != "undefined"){
        var defaultBulkValue = defaultVariant.options[0];
      }

      this.mainElement.productData.variants.forEach((variant, index) => {
        var bulkValue = variant.options[0];
        var found = true;
        var available = true;
        for (var i = 1; i < variant.options.length; i++) {
          // Search for equal variant names (i.e. S/S/S, M/M/M, L/L/L)
          if(bulkValue != variant.options[i]){
            found = false;
            break;
          }
        }
        if(found){
          if (variant && (!variant.available || (variant.inventory_quantity != null && variant.inventory_quantity <= parseInt(this.mainElement.dataset.inventoryThreshold)))) {
            available = false;
          } else {
            available = true;
          }
          if(typeof defaultBulkValue != 'undefined' && bulkValue == defaultBulkValue){
            newDefaultValue = bulkValue;
            this.variantsElement.querySelector('.single-option-selector').value = variant.id;
          }else if(!newDefaultValue && available){
            newDefaultValue = bulkValue;
            this.variantsElement.querySelector('.single-option-selector').value = variant.id;
          }
          var optionsKey = options.map((temp) => temp['value']).indexOf(bulkValue);
          options[optionsKey].available = available;
          switch (options[optionsKey].value) {
            case 'Small':
              options[optionsKey].index = 1;
              break;
            case 'Small Wide Calf':
              options[optionsKey].index = 2;
              break;
            case 'Medium':
                options[optionsKey].index = 3;
                break;
            case 'Medium Wide Calf':
              options[optionsKey].index = 4;
              break;
            case 'Large':
              options[optionsKey].index = 5;
              break;
            case 'Large Wide Calf':
              options[optionsKey].index = 6;
              break;
            case 'Extra Large':
              options[optionsKey].index = 7;
              break;
            default:
              break;
          }


          bulkOptions.push(options[optionsKey]);
        }
      });

      if(newDefaultValue){
        defaultValue = newDefaultValue;
        this.variantsElement.bulkDefaultValue = defaultValue;
        var defaultValueSet = true;
      }else{
        var defaultValueSet = false;
      }


      bulkOptions.sort((a, b) => a.index - b.index).forEach((option, index)=>{
        var optionNameHandle = $s.handleize(this.label);
        var optionValueHandle = $s.handleize(option.value);
        var id = `swatch-${this.optionNumber}-${$s.handleize(option.value)}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`;
        var soldOut = (!option.available ? '<span class="visually-hidden"> (Sold Out)</span>' : '');

        if(!defaultValueSet && option.index && option.available){
          defaultValue = option.value;
          this.variantsElement.bulkDefaultValue = option.value;
          defaultValueSet = true;
        }

        let shortOption = '';

        switch (option.value) {
          case 'Small':
            shortOption = 'S';
            break;
          case 'Small Wide Calf':
            shortOption = 'SW';
            break;
          case 'Medium':
            shortOption = 'M';
            break;
          case 'Medium Wide Calf':
            shortOption = 'MW';
            break;
          case 'Large':
            shortOption = 'L';
            break;
          case 'Large Wide Calf':
            shortOption = 'LW';
            break;
          case 'Extra Large':
            shortOption = 'XL';
            break;
          default:
            break;
        }

        const optionValueSoldOut = `${option.value}${soldOut}`;
        const shortOptionSoldOut = `${shortOption}${soldOut}`;

        html += `
          <div class="swatch" data-available="${option.available}" >
            <span data-variant-price-option="${option.value}"></span>
            <input type="radio" id="${id}" name="swatch-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}" value="${$s.escapeDomAttribute(option.value)}" />
            <label for="${id}">
              <div class="label-inner flex align-items-center justify-content-center animation ${optionNameHandle}-${optionValueHandle}">
                <span>${shortOption != '' ? shortOptionSoldOut : optionValueSoldOut}</span>
              </div>
            </label>
          </div>
        `;
      });

      var group = this.querySelector('.swatch-group');
      group.innerHTML = html;

      if (this.required()) {
        this.setAttribute('data-required', 'true');
        group.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
        }, {once: true})
      } else {
        this.setAttribute('data-required', 'false');
        if(defaultValue && group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]')) {
          group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]').checked = true;
        } else {
          group.querySelector('input').checked = true;
        }
      }
      group.addEventListener('change', (event)=>{
        var valueBulk = event.target.value;
        this.variantsElement.querySelectorAll('product-swatch').forEach((productSwatch, index)=>{
          productSwatch.querySelectorAll('.swatch').forEach((swatch, index2)=>{
            if(valueBulk == swatch.querySelector('input[type=radio]').value){
              swatch.querySelector('input[type=radio]').click();
            }
          });
        });

        this.updateVariantIdURL(this.variantsElement.querySelector('.single-option-selector').value);
      });

    }

    updateVariantIdURL(id, paramName='variant_id') {
      const nextURL = new URL(window.location.href, location.origin);
      nextURL.searchParams.set(paramName, id);
      window.history.replaceState(null, null, nextURL);
    }
  }
  customElements.define('product-swatch-bulk', ProductSwatchBulk);
}

if(!customElements.get('product-swatch')) {
  class ProductSwatch extends HTMLElement {
  	constructor() {
      super();
      this.colorSwatchesOptions = ["Color"]
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';
      this.setAttribute('aria-labelledby', `swatchgroup-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`);

      this.buildOptionSelector();
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = this.variantsElement.bulkDefaultValue?this.variantsElement.bulkDefaultValue:currentVariant.options[this.optionNumber-1];
      var self = this;

      /* Default from param */
      var paramVarId = parseInt($s.getQueryParam('variant_id'));
      var variantFromParam = this.mainElement.productData.variants.find((x)=>{
        return x.id == paramVarId;
      });
      if(variantFromParam){
        defaultValue = variantFromParam.options[this.dataset.option-1];
        this.variantsElement.querySelector('.single-option-selector').value = paramVarId;
      }
      /* Default from param */

    	var optionElement = document.createElement('div');
      var mainElementId = this.mainElement.dataset.productId;
      var optionNameHandle = $s.handleize(this.label);
      if (this.label.toLowerCase() == 'color') {
        var html = `
        <div class="option-name">
          <!--${this.infoIcon}
          <span id="${this.getAttribute('aria-labelledby')}">${this.label}: </span>-->
          <span aria-hidden="true" class="option-value">${defaultValue}</span>
          <!--${this.infoLink}-->
        </div>
        <div class="swatch-group flex flex-wrap"></div>
  		`;
      } else if (this.mainElement.classList.contains('template-leggings') && this.label.indexOf('Size') > -1) {
        var html = `
          <div class="option-name">
            <span id="${this.getAttribute('aria-labelledby')}">Size:</span>
            <span aria-hidden="true" class="option-value">${String(defaultValue).replace(/-/g, '–')}</span>
          </div>
          <div class="swatch-group flex"></div>
        `;
      } else {
        var html = `
          <div class="option-name">
            ${this.infoIcon}
            <span id="${this.getAttribute('aria-labelledby')}">${this.label.replace(' ', '').replace('-', ': ')} </span>
            <!--<span aria-hidden="true" class="option-value">${defaultValue}</span>
            ${this.infoLink}-->
          </div>
          <div class="swatch-group flex"></div>
        `;
      }
  		this.innerHTML = html;
      this.sortArrayByValue(optionValues)
      setTimeout(()=>{        
        self.buildOptions(optionValues, defaultValue);
      }, 1);
    }

    sortArrayByValue(arr) {
      // Assign index based on value
      arr.forEach(options => {
        switch (options.value) {
          case 'Small':
            options.index = 1;
            break;
          case 'Small Wide Calf':
            options.index = 2;
            break;
          case 'Medium':
            options.index = 3;
            break;
          case 'Medium Wide Calf':
            options.index = 4;
            break;
          case 'Large':
            options.index = 5;
            break;
          case 'Large Wide Calf':
            options.index = 6;
            break;
          case 'Extra Large':
            options.index = 7;
            break;
          default:
            options.index = 999; // Assign a high index for unknown values
            break;
        }
      });

      // Sort the array based on the index
      arr.sort((a, b) => a.index - b.index);

      // Remove the index property if needed
      arr.forEach(options => {
        delete options.index;
      });

      return arr;
    }

    buildOptions(options, defaultValue) {
    	var html = '';
      if (options.length > 0) {
        this.setAttribute('role', 'radiogroup');
      }
      if (options.length == 1){
        this.style.display = 'none';
      }
  		options.forEach((option, index)=>{
        var optionNameHandle = $s.handleize(this.label);
        var optionValueHandle = $s.handleize(option.value);
        var id = `swatch-${this.optionNumber}-${$s.handleize(option.value)}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`;
        var soldOut = (!option.available ? '<span class="visually-hidden"> (Sold Out)</span>' : '');

        let shortOption = '';

        switch (option.value) {
          case 'Small':
            shortOption = 'S';
            break;
          case 'Small Wide Calf':
            shortOption = 'SW';
            break;
          case 'Medium':
            shortOption = 'M';
            break;
          case 'Medium Wide Calf':
            shortOption = 'MW';
            break;
          case 'Large':
            shortOption = 'L';
            break;
          case 'Large Wide Calf':
            shortOption = 'LW';
            break;
          case 'Extra Large':
            shortOption = 'XL';
            break;
          default:
            break;
        }

        const optionValueSoldOut = `${option.value}${soldOut}`;
        const shortOptionSoldOut = `${shortOption}${soldOut}`;

        let labelText = shortOption != '' ? shortOptionSoldOut : optionValueSoldOut;
        if (this.mainElement.classList.contains('template-leggings') && this.label.indexOf('Size') > -1) {
          const sizeParts = option.value.match(/^(.+?)\s*\((.+)\)$/);
          if (sizeParts) {
            labelText = `<span class="size-abbr">${sizeParts[1]}</span> <span class="size-range">${sizeParts[2].replace(/-/g, '–')}</span>${soldOut}`;
          }
        }

        if(this.mainElement.classList.contains('gift-cards')){
          option.available = true;
        }

  			html += `
          <div class="swatch" data-available="${option.available}">
            <span data-variant-price-option="${option.value}"></span>
            <input type="radio" id="${id}" name="swatch-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}" value="${$s.escapeDomAttribute(option.value)}" />
  				  <label for="${id}">
              <div class="label-inner flex align-items-center justify-content-center animation ${this.colorSwatchesOptions.indexOf(this.label)>-1 ? 'color-'+optionValueHandle : ''} ${optionNameHandle}-${optionValueHandle}">
              	<span>${labelText}</span>
              </div>
            </label>
          </div>
  			`;
  		});
  		var group = this.querySelector('.swatch-group');
  		group.innerHTML = html;

      if (this.required()) {
        this.setAttribute('data-required', 'true');
        group.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
        }, {once: true})
      } else {
        this.setAttribute('data-required', 'false');
        if(defaultValue && group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]')) {
          group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]').checked = true;
        } else {
          group.querySelector('input').checked = true;
        }
      }
    }
  }
  customElements.define('product-swatch', ProductSwatch);
}

if(!customElements.get('product-dropdown')) {
  class ProductDropdown extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';

      this.buildOptionSelector();

      if (this.required()) {
        var select = this.querySelector('select');
        this.setAttribute('data-required', 'true');
        select.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
          select.querySelector('[disabled]').remove();
        }, {once: true})
      }
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];

      var optionId = 's-' + this.mainElement.sectionId+'-option-'+this.optionNumber + '-' + this.variantsElement.instanceIndex;
      var optionElement = document.createElement('div');
      var html = `
        <label class="option-name" for="${optionId}">
        ${this.infoIcon}${this.label}: 
        ${this.infoLink}
        </label>
        <div class="field">
          <svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path d="M27,10,16,22,5,10"/></svg> 
          <select id="${optionId}" name="swatch-${optionId}"></select>
        </div>
      `;
      this.innerHTML = html;
      this.buildOptions(optionValues, defaultValue);
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
      if (this.required()) {
  			html += `<option value="${defaultValue || ''}" disabled selected>${lngg.general__forms__select_option_label}</option>`;
      } else {
        this.setAttribute('data-required', 'false');
      }
  		options.forEach((option, index)=>{
  			let soldOut = (!option.available ? lngg.product_main__sold_out_option_value : '');
  			html += `<option value="${$s.escapeDomAttribute(option.value)}">${option.value}${soldOut}</option>`;
  		});
  		var select = this.querySelector('select');
  		select.innerHTML = html;

  		if(defaultValue) {
    		var newValueIndex = Array.from(select.options).findIndex(x=>x.value==defaultValue);
    		if(newValueIndex>=0) {
    			select.selectedIndex = newValueIndex;
    		}
  		}
    }
  }
  customElements.define('product-dropdown', ProductDropdown);
}

if(!customElements.get('product-model')) {
  class ProductModel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = document.querySelector('.product-main-element[data-product-id="'+this.dataset.productId+'"]');

      window.Shopify.loadFeatures([{
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXr.bind(this)
      }]);
    }

    setupShopifyXr() {
      if(!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', ()=>{
          this.setupShopifyXr();
        });
      } else {
        window.ShopifyXR.addModels(this.mainElement.productData.media.filter(x=>x.media_type=='model'));
        setTimeout(()=>{
          window.ShopifyXR.setupXRElements();
        }, 100);
      }
    }
  }
  customElements.define('product-model', ProductModel);
}

if(!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
        if(e.detail.variant && e.detail.variant.available) {
          this.fetchAvailability(e.detail.variant.id);
        } else {
          this.innerHTML = '';
        }
      });
    }

    fetchAvailability(variantId) {
      let rootUrl = routes.root_url;
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup_availability`;

      $s.get({
        url: variantSectionUrl,
        success: (data)=>{
          this.innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section').innerHTML;
          this.bindEvents();
        },
        error: ()=>{
          this.innerHTML = '';
        }
      });
    }

    bindEvents() {
      let button = this.querySelector('.pickup-popup-trigger');
      if(button) {
        button.addEventListener('click', ()=>{
          $s.openModal(this.querySelector('.pickup-availability-info'), 'pickup-availability-info-modal');
        });
      }
    }
  }
  customElements.define('pickup-availability', PickupAvailability);
}

if(!window.reviewStarsScrollBound) {
  window.reviewStarsScrollBound = true;
  // Okendo only makes the stars clickable on the panel visible at load, so stars on any colour
  // panel revealed later need their own scroll to the reviews.
  document.addEventListener('click', (e)=>{
    const stars = e.target.closest('[data-oke-star-rating]');
    if (!stars || e.target.closest('.oke-is-clickable')) { return; }
    const widget = [...document.querySelectorAll('[data-oke-widget]')].find(el=>el.offsetWidth);
    if (!widget) { return; }
    const headerOffset = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
    window.scrollTo({top: widget.getBoundingClientRect().top + window.scrollY - headerOffset, behavior: 'smooth'});
  });
}

if(!customElements.get('product-group-selector')) {
  class ProductGroupSelector extends HTMLElement {
    constructor() {
      super();
      this.productGroup = this.closest('product-group');
      this.addEventListener('change', this.showProduct.bind(this));

      // Reserved column heights are measured for one viewport, so drop them when the breakpoint
      // changes rather than leave the layout holding a reservation taken at another width. This
      // listens to the theme's own debounced `mediaChange`, not `resize`: on mobile `resize` also
      // fires when the address bar collapses mid-scroll, which would drop the reservation — and
      // shrink the column — while the shopper is simply scrolling.
      this.clearReservedHeights = ()=>{
        if (!this.productGroup) { return; }
        this.productGroup.querySelectorAll('.product-main-element sticky-updown').forEach(el=>{
          el.style.minHeight = '';
        });
      };
    }

    connectedCallback() {
      const inputSelected = this.querySelector('[type=radio]:checked');
      if (!inputSelected) {
        const prodId = $s.getQueryParam('product');
        const input = this.querySelector('[type=radio][value="'+prodId+'"]') || this.querySelector('[type=radio]');
        // Initial selection on page load: leave the scroll position to the browser
        // (its own scroll restoration, #anchor deep links) instead of preserving it.
        this.initialSelection = true;
        input.click();
        this.initialSelection = false;
      }
      window.addEventListener('mediaChange', this.clearReservedHeights);
      this.preloadPanels();
    }

    disconnectedCallback() {
      window.removeEventListener('mediaChange', this.clearReservedHeights);
    }

    // Clone one product panel out of the group's template, always hidden: a panel that enters the
    // layout visible puts a second full product on the page for a frame. Its images are parked
    // because a hidden panel has no layout box, so lazysizes reads them as in-viewport and fetches
    // them all — revealPanelImages() hands them back when the colour is actually opened.
    createPanel(productId) {
      const group = this.productGroup;
      const template = group && group.querySelector('template');
      if (!template) { return null; }
      if (group.querySelector('.product-main-element[data-product-id="'+productId+'"]')) { return null; }

      const templateContent = template.content.cloneNode(true);
      const panel = templateContent.querySelector('.product-main-element[data-product-id="'+productId+'"]');
      if (!panel) { return null; }

      panel.style.display = 'none';
      panel.querySelectorAll('img.lazyload').forEach(img=>{
        img.classList.remove('lazyload');
        img.classList.add('lazyload-deferred');
      });
      group.insertAdjacentElement('beforeend', panel);
      return panel;
    }

    revealPanelImages(panel) {
      panel.querySelectorAll('img.lazyload-deferred').forEach(img=>{
        img.classList.remove('lazyload-deferred');
        img.classList.add('lazyload');
      });
    }

    // Every colour is a separate panel, otherwise cloned on its first click. A panel revealed in the
    // same frame it was created paints once at its static position before the browser resolves its
    // sticky offset, which reads as a flash. Build them ahead of time while the browser is idle, one
    // per slice, so no click ever lands on a brand-new panel.
    preloadPanels() {
      const group = this.productGroup;
      if (!group || group.dataset.panelsPreloaded || !group.querySelector('template')) { return; }
      group.dataset.panelsPreloaded = 'true';

      const pending = [...this.querySelectorAll('[type=radio]')].map(input=>input.value);
      const schedule = window.requestIdleCallback ? window.requestIdleCallback.bind(window) : (cb)=>setTimeout(cb, 200);
      const buildNext = ()=>{
        // Stop if the component was torn down (theme editor re-render). `isConnected` rather than a
        // disconnectedCallback flag, because showProduct moves this element on every swap, which
        // disconnects and reconnects it — by the time a slice runs it is attached again.
        if (!this.isConnected) { return; }
        const productId = pending.shift();
        if (productId == null) { return; }
        this.createPanel(productId);
        schedule(buildNext);
      };
      schedule(buildNext);
    }

    // The swap forces several synchronous reflows, and the browser recomputes the scroll offset
    // against that transient layout — which is what made the page jump. Returns the function that
    // puts the shopper back. On the initial page-load selection it is a no-op, so the browser keeps
    // ownership of its own scroll restoration and of `#anchor` deep links.
    keepScrollPosition() {
      // Drop the previous swap's pending frame: on a fast double switch it would otherwise fire
      // after this one and put the shopper back at the older coordinates.
      cancelAnimationFrame(this.restoreScrollFrame);
      if (this.initialSelection) { return ()=>{}; }

      const scrollX = window.scrollX;
      const scrollY = window.scrollY;
      const restore = ()=>{
        if (window.scrollX != scrollX || window.scrollY != scrollY) {
          window.scrollTo(scrollX, scrollY);
        }
      };
      return ()=>{
        restore();
        // Catch the relayout that lands after this task (slider refresh, lazy-loaded imagery).
        this.restoreScrollFrame = requestAnimationFrame(restore);
      };
    }

    // Products in a group rarely have identical content — a different number of sizes wraps the swatch
    // grid onto an extra row — so the info column changes height across the swap. That shortens the
    // row, the sticky gallery loses travel room, and it jumps even though the scroll never moved.
    // Only the info column is measured: the media column's height belongs to the carousel, which is
    // still un-slid at this point, so measuring it would lock in a bogus value.
    // Addressed by class rather than by DOM order, so the media column's offset can never land on
    // the info column if the markup ever grows another sticky element.
    stickyColumns(panel) {
      return {
        media: panel.querySelector('sticky-updown.main-product-media'),
        info: panel.querySelector('sticky-updown.main-product-info')
      };
    }

    captureColumnLayout(panel) {
      if (!panel) { return null; }
      const columns = this.stickyColumns(panel);
      if (columns.info) { columns.info.style.minHeight = ''; }
      const offsetOf = el=>el && el.captureOffset ? el.captureOffset() : null;
      return {
        info: columns.info,
        infoHeight: columns.info ? columns.info.offsetHeight : 0,
        offsets: { media: offsetOf(columns.media), info: offsetOf(columns.info) }
      };
    }

    adoptColumnLayout(panel, captured) {
      if (!captured) { return; }
      const columns = this.stickyColumns(panel);

      // Reserve the taller of the two info columns on both panels, so the row height — and with it
      // the sticky gallery — stays put across the swap.
      if (columns.info && captured.infoHeight) {
        columns.info.style.minHeight = '';
        const reservedHeight = Math.max(captured.infoHeight, columns.info.offsetHeight);
        columns.info.style.minHeight = reservedHeight + 'px';
        if (captured.info) { captured.info.style.minHeight = reservedHeight + 'px'; }
      }

      if (columns.media && columns.media.applyOffset) { columns.media.applyOffset(captured.offsets.media); }
      if (columns.info && columns.info.applyOffset) { columns.info.applyOffset(captured.offsets.info); }
    }

    updateProdIdURL(prodId, variantId=false) {
      const nextURL = new URL(window.location.href, location.origin);
      nextURL.searchParams.set('product', prodId);
      if(variantId){
        nextURL.searchParams.set('variant_id', variantId);
      }
      window.history.replaceState(null, null, nextURL);
    }

    showProduct(e) {
      var self = this;
      const id = e.target.value;
      const restoreScroll = this.keepScrollPosition();

      const optionsString = e.target.closest('.grid-item').dataset.productOptionsString;
      const productChildName = this.querySelector('.product-child-name');
      const productChildNameSpan = this.querySelector('.product-child-name .option-name-span');

      // If the panel cannot be resolved (a combined_products entry with no matching markup in the
      // template), leave the current product on screen rather than hiding it and showing nothing.
      const targetPanel = this.productGroup.querySelector('.product-main-element[data-product-id="'+id+'"]') || this.createPanel(id);
      if (!targetPanel) { return; }

      const panels = this.productGroup.querySelectorAll('.product-main-element');

      // Measure the outgoing panel while it is still laid out — adoptColumnLayout() needs it to keep
      // the row height, and with it the sticky gallery, from moving across the swap.
      const outgoingPanel = [...panels].find(p=>p.dataset.productId!=id && p.style.display!='none');
      const outgoingLayout = this.captureColumnLayout(outgoingPanel);

      // Hide the outgoing panels first, so two panels are never laid out at the same time.
      panels.forEach(panel=>{
        if (panel.dataset.productId!=id) {
          panel.style.display = 'none';
        }
      });

      panels.forEach(panel=>{
        if (panel.dataset.productId==id) {
          panel.style.display = 'block';
          this.revealPanelImages(panel);
          this.adoptColumnLayout(panel, outgoingLayout);

          panel.querySelector('product-variants')?.insertAdjacentElement('beforebegin', this);

          const sizeGuidePopupTrigger = panel.querySelector('.size-guide-popup-trigger');

          // Size Guide Trigger Start
          if (sizeGuidePopupTrigger) {
            panel.querySelector('.product-main-element .product-swatch-size-guide .product-swatch .option-name').appendChild(sizeGuidePopupTrigger);
          }
          // Size Guide Trigger End

          // Compression Level Trigger Start
          this.compressionLevelWrapper = panel.querySelector('.compression-level-wrapper');

          if (this.compressionLevelWrapper) {
            panel.querySelector('.product-main-element .product-swatch-size-guide').appendChild(this.compressionLevelWrapper);
          }
          // Compression Level Trigger End

          if(panels.length > 1){
            var variantId = panel.querySelector('product-variants .single-option-selector').value;
            self.updateProdIdURL(id, variantId);
          }else{
            self.updateProdIdURL(id);
          }

          const carousels = panel.querySelectorAll('product-gallery, product-thumbs');
          carousels.forEach(c=>{
            if (c.slider) { c.removeSlider(); }
            c.onMediaChange();
          });

          // Reset quantity buttons to default (1 Pair)
          const defaultQtyBtn = panel.querySelector('.quantity-buttons__btn[data-quantity="1"]');
          if (defaultQtyBtn) {
            defaultQtyBtn.click();
          }

          e.target.focus({ preventScroll: true });
        }
      })
      productChildNameSpan.innerHTML = optionsString;

      if (optionsString == '') {
        productChildName.style.display = 'none';
      } else {
        productChildName.style.display = 'block';
      }

      restoreScroll();
    }

  }
  customElements.define('product-group-selector', ProductGroupSelector);
}



